const cheers = () => {
    const element = document.querySelector('.cheers-text-animation');
    if (!element) return;

    let hasAnimated = false;
    let elementOffsetTop = null;
    let elementHeight = null;

    // Tạo placeholder element để giữ chỗ khi fixed
    const placeholder = document.createElement('div');
    placeholder.className = 'cheers-placeholder';
    element.parentNode.insertBefore(placeholder, element);

    // Lấy vị trí ban đầu của element (chỉ tính 1 lần)
    const getElementOffset = () => {
        if (elementOffsetTop === null) {
            // Tính vị trí ban đầu khi element chưa có class fixed
            element.classList.remove('fixed');
            const rect = element.getBoundingClientRect();
            elementOffsetTop = rect.top + window.pageYOffset;
            elementHeight = element.offsetHeight;
            placeholder.style.height = '0px';
        }
    };

    // Gọi lần đầu sau khi load
    setTimeout(getElementOffset, 100);

    // Handle scroll để thêm/bỏ class fixed
    const handleScroll = () => {
        getElementOffset();

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Nếu top của element chạm hoặc vượt top của window
        if (scrollTop >= elementOffsetTop) {
            if (!element.classList.contains('absolute') && !element.classList.contains('fixed')) {
                // Bước 1: Chuyển thành absolute trước (vẫn giữ nguyên vị trí)
                placeholder.style.height = elementHeight + 'px';
                element.classList.add('absolute');
                element.style.top = (elementOffsetTop - scrollTop) + 'px';
            }
            
            // Bước 2: Khi đã absolute, check xem có cần chuyển thành fixed không
            if (element.classList.contains('absolute') && scrollTop >= elementOffsetTop) {
                element.classList.remove('absolute');
                element.classList.add('fixed');
                element.style.top = '0px';
            }
        } 
        // Nếu scroll xuống về vị trí ban đầu
        else if (scrollTop < elementOffsetTop) {
            if (element.classList.contains('fixed') || element.classList.contains('absolute')) {
                element.classList.remove('fixed');
                element.classList.remove('absolute');
                element.style.top = '';
                placeholder.style.height = '0px';
            }
        }
    };

    // Lắng nghe sự kiện scroll với throttle
    let ticking = false;
    const onScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScroll);
    
    // Kiểm tra ngay lần đầu
    handleScroll();

    // Khởi tạo state ban đầu
    anime.set('.cheers-text-animation .part.left', {
        translateX: '-120%',
        opacity: 0
    });
    anime.set('.cheers-text-animation .part.right', {
        translateX: '120%',
        opacity: 0
    });

    // Hàm chạy animation
    const playAnimation = () => {
        const tl = anime.timeline({ autoplay: true });

        // Bước 1: Trượt vào với tăng tốc dần (chậm -> nhanh -> rất nhanh)
        tl.add({
            targets: '.cheers-text-animation .part.left',
            translateX: ['-120%', '0%'],
            opacity: [0, 1],
            duration: 700,
            easing: 'easeInQuart' // tăng tốc mạnh hơn (Cubic -> Quart)
        }, 0)
        .add({
            targets: '.cheers-text-animation .part.right',
            translateX: ['120%', '0%'],
            opacity: [0, 1],
            duration: 700,
            easing: 'easeInQuart' // tăng tốc mạnh để đập mạnh
        }, 0)
        
        // Đập: SQUASH vừa phải + nảy nhẹ nhàng
        .add({
            targets: '.cheers-text-animation .item',
            scaleX: [
                { value: 0.82, duration: 100, easing: 'easeOutQuad' },  // dúm vừa (từ 65% -> 82%)
                { value: 1.05, duration: 160, easing: 'easeOutElastic(1, .8)' }, // nảy mượt
                { value: 1, duration: 100, easing: 'easeOutQuad' }      // về bình thường
            ],
            scaleY: [
                { value: 1.18, duration: 100, easing: 'easeOutQuad' },  // phình vừa (từ 135% -> 118%)
                { value: 0.95, duration: 160, easing: 'easeOutElastic(1, .8)' }, // ép mượt
                { value: 1, duration: 100, easing: 'easeOutQuad' }      // về bình thường
            ]
        }, '-=120') // overlap nhiều hơn để đập ngay khi gặp
        
        // Va chạm lần 2: co giãn nhẹ nhàng
        .add({
            targets: '.cheers-text-animation .item',
            scaleX: [
                { value: 0.92, duration: 80, easing: 'easeInQuad' },
                { value: 1.03, duration: 120, easing: 'easeOutQuad' },
                { value: 1, duration: 80, easing: 'easeOutQuad' }
            ],
            scaleY: [
                { value: 1.08, duration: 80, easing: 'easeInQuad' },
                { value: 0.97, duration: 120, easing: 'easeOutQuad' },
                { value: 1, duration: 80, easing: 'easeOutQuad' }
            ]
        })
        
        // Va chạm lần 3: co giãn rất nhẹ (settle down mượt mà)
        .add({
            targets: '.cheers-text-animation .item',
            scaleX: [
                { value: 0.97, duration: 70, easing: 'easeInOutQuad' },
                { value: 1.01, duration: 100, easing: 'easeOutQuad' },
                { value: 1, duration: 80, easing: 'easeOutQuad' }
            ],
            scaleY: [
                { value: 1.03, duration: 70, easing: 'easeInOutQuad' },
                { value: 0.99, duration: 100, easing: 'easeOutQuad' },
                { value: 1, duration: 80, easing: 'easeOutQuad' }
            ]
        });
    };

    // Intersection Observer để phát hiện khi scroll đến
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !hasAnimated) {
                hasAnimated = true;
                playAnimation();
                observer.unobserve(element); // Chỉ chạy 1 lần
            }
        });
    }, {
        threshold: 0.3, // Chạy khi 30% phần tử hiện trong viewport
        rootMargin: '0px 0px -100px 0px' // Offset từ dưới lên
    });

    observer.observe(element);
}

module.exports = cheers;